module.exports = __webpack_public_path__ + "img/money-xs.dce2c52a.svg";